import amplitude from 'amplitude-js'
import { useCallback } from 'react'

export const initAmplitude = () => {
    amplitude.getInstance().init('de9b3a0a206c372d93860a6f78522897')
}
export function useAmplitude() {
    const setAmplitudeUserDevice = (installationToken: any) => {
        amplitude.getInstance().setDeviceId(installationToken)
    }

    const setAmplitudeUserId = (userId: any) => {
        amplitude.getInstance().setUserId(userId)
    }

    const setAmplitudeUserProperties = (properties: any) => {
        amplitude.getInstance().setUserProperties(properties)
    }

    const AmplitudeLog = useCallback((eventType: any, eventProperties: any) => {
        amplitude.getInstance().logEvent(eventType, eventProperties)
    }, [])

    return {
        initAmplitude,
        setAmplitudeUserProperties,
        setAmplitudeUserDevice,
        setAmplitudeUserId,
        log: AmplitudeLog,
    }
}
